import { render, staticRenderFns } from "./PrivacyPolicyEN.vue?vue&type=template&id=460bf9c6&scoped=true&"
var script = {}
import style0 from "./PrivacyPolicyEN.vue?vue&type=style&index=0&id=460bf9c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460bf9c6",
  null
  
)

export default component.exports